import { render } from "./QrCode.vue?vue&type=template&id=b2d5aa5a&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"

import "./QrCode.vue?vue&type=style&index=0&id=b2d5aa5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d5aa5a"]])

export default __exports__